module.exports = __webpack_public_path__ + "img/photo-nrg.f5dbd31c.jpg";